import { bindable, computedFrom } from 'aurelia-framework';

class SimpleTable {
  @bindable loading = false;
  @bindable showSearch = true;
  @bindable usePagination = true;
  @bindable searchText = '';
  @bindable items = [];
  @bindable total = 0;
  @bindable itemsPerPage = 0;
  @bindable itemsCurrentPage = 0;
  @bindable itemsTotalPages = 0;
  @bindable itemsLimitCaption = { start: 0, end: 0 };
  @bindable itemsLimit = { offset: 0, limit: 0 };
  @bindable sortBy = 'name';
  @bindable sortAsc = true;
  @bindable columns = [
    {
      id: 'name',
      title: 'Name',
      sortEnabled: false,
    },
  ];
  @bindable actions = [];
  @bindable onMoveNext = () => {};
  @bindable onMoveBack = () => {};
  @bindable onSearchTextChange = () => {};
  @bindable onSearchBoxAttached = () => {};
  @bindable onSortChange = () => {};
  @bindable onActionClick = () => {};
  headers = [];
  columnsChanged() {
    this._generateHeaders();
  }
  sortAscChanged() {
    this._generateHeaders();
  }
  sortByChanged() {
    this._generateHeaders();
  }
  sortTable($event, column) {
    $event.target.blur();
    this.onSortChange({
      column: column.id,
    });
  }
  @computedFrom('loading', 'usePagination')
  get showPaginatedTable() {
    return !this.loading && this.usePagination;
  }
  @computedFrom('loading', 'usePagination')
  get showUnpaginatedTable() {
    return !this.loading && !this.usePagination;
  }
  _generateColumnDetail(column, detail) {
    detail.link = !!detail.link;
    detail.useFullLine = !!detail.useFullLine;
    detail.useElipsis = false;
    if (!detail.maxWidth) {
      detail.maxWidth = '100%';
    } else {
      detail.useElipsis = true;
      detail.useFullLine = false;
      // User set maximum width parameter must be in integers
      const maxWidth = parseInt(detail.maxWidth, 10);
      detail.maxWidth = `${maxWidth}px`;
      column.minWidth = column.minWidth > maxWidth ? column.minWidth : maxWidth;
    }
    detail.useFullLine = !!detail.useFullLine;
    if (detail.useFullLine) {
      detail.maxWidth = '100%';
    }
    if (!detail.fallback) {
      detail.fallback = '';
    }
    return detail;
  }
  _generateHeaders() {
    const sortDesc = !this.sortAsc;
    this.headers = this.columns.map((column) => {
      const selected = column.id === this.sortBy;
      const isForActions = column.id === 'actions';
      let hasDetails = false;
      let hasThumbnail = false;
      if (!isForActions && column.thumbnail && column.thumbnail.id) {
        hasThumbnail = true;
        column.thumbnail.link = !!column.thumbnail.link;
      }
      column.minWidth = 0;
      if (!isForActions && column.details && column.details.length > 0) {
        hasDetails = true;
        column.details.forEach((detail) => this._generateColumnDetail(column, detail));
      }
      const header = Object.assign({}, column, {
        hasDetails,
        isForActions,
        link: !!column.link,
        selected,
        showIcon: selected && column.sortEnabled,
        sortAsc: this.sortAsc,
        sortDesc,
        hasThumbnail,
      });

      return header;
    });
  }
}

export { SimpleTable };
